import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { DelaStarIcon } from '~/modules/common/components';
import { useHasFeatureFlag } from '~/modules/common/hooks';
import { useMarkAttachmentsAsRead } from '~/modules/attachments/AttachmentsBlock/hooks';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    backgroundColor: theme.palette.grey[600],
    marginTop: theme.spacing(2.5),
    padding: theme.spacing(1.75),
    borderRadius: theme.spacing(3)
  },
  root2: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(0, 1.5),
    marginTop: theme.spacing(3)
  },
  column: {
    display: 'flex',
    flexDirection: 'column'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    width: '65%'
  },
  textContainer: {
    display: 'flex'
  },
  text: {
    color: theme.palette.common.white
  },
  text2: {
    color: theme.palette.text.main,
    fontWeight: 600
  },
  button: {
    marginTop: theme.spacing(1.75),
    padding: theme.spacing(0.75, 3, 0.75, 3),
    borderRadius: theme.spacing(2.5),
    color: theme.palette.common.white,
    backgroundImage: `linear-gradient(119deg, ${theme.palette.Dela.button.gradient.purple} 17.59%, ${theme.palette.Dela.button.gradient.blue} 77.78%)`,
    boxShadow: 'none'
  },
  button2: {
    marginTop: theme.spacing(1.75),
    padding: theme.spacing(0.5, 1.25),
    color: theme.palette.common.white,
    boxShadow: 'none',
    textTransform: 'uppercase',
    width: 'fit-content',
    fontWeight: 400,
    fontSize: theme.spacing(1.5)
  }
}));

const useDelaStarIconStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(0, 1),
    fill: theme.palette.common.white,
    fontSize: theme.spacing(4)
  }
}));

const useDelaStarIconStyles2 = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(-0.5),
    fill: theme.palette.Dela.darkIcon,
    fontSize: theme.spacing(1.75)
  }
}));

export const DelaResourceRequestsNotification = ({ attachments }) => {
  const isPsaPraaResourceMatchingEnabled = useHasFeatureFlag({
    featureFlag: 'isPsaPraaResourceMatchingEnabled'
  });
  const classes = useStyles();
  const delaStarIconClasses = useDelaStarIconStyles();
  const delaStarIconClasses2 = useDelaStarIconStyles2();
  const history = useHistory();

  const { markAttachmentsAsRead } = useMarkAttachmentsAsRead();

  const handler = useCallback(() => {
    markAttachmentsAsRead({
      binaryObjectUris: attachments.map(attachment => attachment.uploadUri)
    });
    history.push({
      pathname: `${history.location.pathname}/resourcingplan`
    });
  }, [markAttachmentsAsRead, attachments, history]);

  return isPsaPraaResourceMatchingEnabled ? (
    <div className={classes.root2}>
      <div className={classes.textContainer}>
        <Typography className={classes.text2} variant="body2">
          <FormattedMessage id="resourceRequestsNotification.createdResourceRequests2" />
        </Typography>
        <DelaStarIcon classes={delaStarIconClasses2} />
      </div>
      <Button
        onClick={handler}
        className={classes.button2}
        variant="contained"
        color="primary"
      >
        <FormattedMessage id="resourceRequestsNotification.viewRequests" />
      </Button>
    </div>
  ) : (
    <div className={classes.root}>
      <div className={classes.column}>
        <DelaStarIcon classes={delaStarIconClasses} />
      </div>
      <div className={classes.column}>
        <div className={classes.row}>
          <Typography className={classes.text} variant="subtitle1">
            <FormattedMessage id="resourceRequestsNotification.createdResourceRequests" />
          </Typography>
        </div>
        <div className={classes.row}>
          <Button
            onClick={handler}
            className={classes.button}
            variant="contained"
          >
            <FormattedMessage id="resourceRequestsNotification.viewResourceRequests" />
          </Button>
        </div>
      </div>
    </div>
  );
};

DelaResourceRequestsNotification.propTypes = {
  attachments: PropTypes.array.isRequired
};

export default DelaResourceRequestsNotification;
